import { Helmet } from "react-helmet-async";
import { DEFAULT_DESCRIPTION, DEFAULT_OG_IMAGE_PATH, getCanonicalOrigin, SITE_NAME, SITE_TAGLINE } from "@/config/site";

/**
 * Méta SEO + Open Graph / Twitter ; canonical basé sur l’URL réelle en client.
 */
export function Seo({
  title,
  description = DEFAULT_DESCRIPTION,
  canonicalPath,
  robots = "index, follow",
  ogType = "website",
  imagePath = DEFAULT_OG_IMAGE_PATH,
  imageAlt,
  jsonLd,
}) {
  const origin = getCanonicalOrigin();
  const pathname =
    typeof window !== "undefined"
      ? canonicalPath ?? `${window.location.pathname}`
      : canonicalPath ?? "/";

  const canonical = `${origin}${pathname.split("?")[0]}`;
  const imageUrl = imagePath?.startsWith("http") ? imagePath : `${origin}${imagePath || DEFAULT_OG_IMAGE_PATH}`;
  const fullTitle = title ? `${title} | ${SITE_NAME}` : `${SITE_NAME} — ${SITE_TAGLINE}`;
  const ogImageAlt = imageAlt || (title ? `${title} — ${SITE_NAME}` : SITE_NAME);
  const twitterCard = imageUrl ? "summary_large_image" : "summary";

  return (
    <Helmet prioritizeSeoTags>
      <html lang="fr" />
      <title>{fullTitle}</title>
      <meta name="description" content={description} />
      <meta name="robots" content={robots} />
      <link rel="canonical" href={canonical} />

      <meta property="og:type" content={ogType} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={description} />
      <meta property="og:url" content={canonical} />
      <meta property="og:locale" content="fr_FR" />
      <meta property="og:site_name" content={SITE_NAME} />
      {imageUrl ? (
        <>
          <meta property="og:image" content={imageUrl} />
          <meta property="og:image:alt" content={ogImageAlt} />
          <meta property="og:image:width" content="1200" />
          <meta property="og:image:height" content="630" />
        </>
      ) : null}

      <meta name="twitter:card" content={twitterCard} />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={description} />
      {imageUrl ? <meta name="twitter:image" content={imageUrl} /> : null}

      {jsonLd ? (
        <script type="application/ld+json">{JSON.stringify(jsonLd)}</script>
      ) : null}
    </Helmet>
  );
}
